/**
 * Funzione per modificare con side effect i dati prima del submit ma dopo
 * la validazione
 */
export type IFormTransformOnSubmitFn = (data: Record<string, any>) => void;

export const FormTransformOnSubmitNoop = () => {};
